// ABOUTME: Prepares the public translation path before mounting external pages.
// ABOUTME: Keeps company-specific external pages on their matching translation path.
import React from "react";
import "../i18n/i18n";
import { i18f, setTranslationPathSource } from "../i18n/i18n";
import HelperLoading from "Components/Loading/HelperLoading";

export const CompanyExternalContext = React.createContext({
    update: (companyId: string) => {},
    value: "0"
});

const UnAuthenticated = (props: any) => {
    const [companyId, setCompanyId] = React.useState("0");
    const [readyTranslationPath, setReadyTranslationPath] = React.useState(() =>
        localStorage.getItem("i18nPath")
    );

    const plan = "noplan";
    const translationPath = `${import.meta.env.VITE_API_ADDRESS}/general/translation/${companyId}/0`;
    React.useEffect(() => {
        const currentPath = localStorage.getItem("i18nPath");

        if (translationPath !== currentPath) {
            i18f(translationPath, "public_route");
        }
        setReadyTranslationPath(translationPath);
    }, [plan, translationPath]);

    if (readyTranslationPath !== translationPath) {
        return <HelperLoading />;
    }

    // Written during render on purpose: children can request translation
    // namespaces while rendering, before any effect runs, and the generic-path
    // diagnostic must attribute them to this transition.
    setTranslationPathSource("public_route");
    const finalElement = React.cloneElement(props.children, {
        ...props
    });
    return (
        <CompanyExternalContext.Provider
            value={{
                update: (companyIdParam: string) => {
                    setCompanyId(companyIdParam);
                },
                value: companyId
            }}
        >
            <React.Fragment>{finalElement}</React.Fragment>
        </CompanyExternalContext.Provider>
    );
};

export default UnAuthenticated;
